import { Navigate } from 'react-router-dom'
import { useAuth, useEncryption } from '@/contexts'
import { PageLoader } from './PageLoader'

interface EncryptedRouteProps {
  children: React.ReactNode
}

// Encrypted route wrapper - requires authentication AND encryption unlocked
export const EncryptedRoute = ({ children }: EncryptedRouteProps) => {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth()
  const { isUnlocked, isLoading: isEncryptionLoading } = useEncryption()

  if (isAuthLoading || isEncryptionLoading) {
    return <PageLoader />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // If authenticated but encryption not unlocked, redirect to unlock page
  if (!isUnlocked) {
    return <Navigate to="/unlock" replace />
  }

  return <>{children}</>
}

export default EncryptedRoute
